module.exports = __webpack_public_path__ + "fonts/6f692e8c102c0036d942d7e306f81173.svg";